export const unitList = [
    { id: 1, name: "ml" },
    { id: 2, name: "gm" },
    { id: 3, name: "kg" }
];

export const typeList = [
    { id: 1, height: 500, width: 500, name: "product-image" },
    { id: 2, height: 500, width: 500, name: "category-image" },
    { id: 3, height: 500, width: 900, name: "carousel-image" },
    { id: 4, height: 400, width: 400, name: "slider-image" },
    { id: 5, height: 400, width: 900, name: "banner-image" },
    { id: 6, height: 400, width: 400, name: "grid-image" },
    { id: 7, height: 100, width: 900, name: "bar-image" }
];



export const pageList = [
    { id: 1, name: "home" },
    { id: 2, name: "categories" },
    { id: 3, name: "cart" },
    { id: 4, name: "package" },
    { id: 5, name: "productlist" },
    { id: 6, name: "productdetails" }
];

export const imageUploadConst = {
    copyLinkLabel: 'Copy',
    copyLinkAfterCopy: 'Copied',
    copyClass: 'copy text-danger',
    copyClassAfterCopy: 'copy text-success'
}

export const appLinks = {
    imageUploadAPIHost: "/admin/upload-s",

    //  
    authLogin: '/auth/login',
    authRefreshToken: '/verify/refresh-token',
    authVerifyPhoneNumber: '/verify/verify-phone-retailer',

    authVerifyPhoneWithOTP: '/verify/verify-phone-check-retailer',
    authVerifyPhoneResendOTP: '/verify/resend-otp',
    userPhoneValidation: '/retailer/phone-validation',


    // Order Links
    getOrdersToday: '/retailer/orders',
    getOrdersHistory: '/retailer/orders-history',
    getOrderById: '/retailer/order/',
    updateOrderDetails: '/retailer/order-status-update',
    updatePickupDetails: '/retailer/update-pickup-details',
    orderStatusPacked: '/retailer/order-status-update-packed',
    orderStatusPackedKitchen: '/retailer/order-status-update-packed-kitchen',
    getBulkOrderAgents: '/retailer/bulk-order-agents',
    assignBulkOrderstoAgent: '/retailer/bulk-orders-assign',
    getTodayOrders: '/retailer/orders-today',

    // Product Links
    getProductLink: '/retailer/get-product',
    getProductsStockLink: '/retailer/get-product-stock',

    // Stock Links
    addStockDetails: '/retailer/stock-add',

    showProductsStock: '/retailer/product-stock',
    showRentalProductsStock: '/retailer/rental-product-stock',
    processRentalProductReturn: '/retailer/rental-product-return',
    showInhouseProductsStock: '/retailer/inhouse-product-stock',
    editProductAvailability: '/retailer/edit-product-availability',
    editProductZonePricing: '/retailer/edit-product-zone-pricing',

    // Order Links
    getOrdersFilterLink: '',
    getOrdersLink: '',

    // Order Management Retailer
    getRetailerOrderLink: '/retailer/order-mngmnt/orders',
    getRetailerOrderFiltersLink: '/retailer/order-mngmnt/filters',
    getRetailerOrderByIdLink: '/retailer/order-mngmnt/orders',
    getSupplierDeliveriesLink: '/retailer/supplier-deliveries',
    getSupplierDeliveryFiltersLink: '/retailer/supplier-delivery-filters',
    getSupplierDeliveryByIdLink: '/retailer/supplier-delivery',
    validateSupplierDeliveryLink: '/retailer/supplier-delivery',
    getRetailerOrdersApproved: '/retailer/retailer-orders-approved',
    createRetailerOrder: '/retailer/order-mngmnt/create-order',
    closeRetailerOrder: '/retailer/order-mngmnt/close-order',

    // Product Alerts 
    getProductAlerts: '/retailer/alerts',
    getProductAlertsCount: '/retailer/alerts-unread-count',
    updateProductAlerts: '/retailer/alert',

    // Store Details
    saveStoreDetails: '/retailer/order-mngmnt/create-storeorder',

    // Stock movements
    getStockMovementLink: '/retailer/stock-movements',
    getStockMovementFiltersLink: '/retailer/stock-movements-filters',

    // User orders

    getUserOrdersLink: '/retailer/user-orders',
    getUserOrdersFiltersLink: '/retailer/user-order-filters',
    getUserOrderByIdLink: '/retailer/user-order',

    // Store orders
    getStoreOrdersLink: '/retailer/user-store-orders',
    getStoreOrdersFiltersLink: '/retailer/user-store-order-filters',
    getStoreOrderByIdLink: '/retailer/user-store-order',

    plCheckStatus: '/retailer/pl-check-status',
    regenratePL: '/retailer/regenerate-pl',
    refundInitiate: '/retailer/refunds/initiate',
    refundCheckStatus: '/retailer/refunds/check-status',
    createReplacement: '/retailer/create-replacement',
    cancelReplacement: '/retailer/cancel-replacement',


    // Dashboard
    dashboardSummaryAPI: '/db/retailer/dashboard/summary',
    dashboardTrendsAPI: '/db/retailer/orders/trend',
    dashboardOrdersBreakdownAPI: '/db/retailer/orders/breakdown',
    dashboarPaymentSummaryAPI: '/db/retailer/payments/summary',
    deliveryPerformanceAPI: '/db/retailer/delivery/performance',
    deliveryAlertsAPI: '/db/retailer/inventory/alerts',

    // Delivery Agent Management
    addDeliveryAgentLink: '/retailer/add-deliveryagent',
    editDeliveryAgentLink: '/retailer/edit-deliveryagent',
    getDeliveryAgentLink: '/retailer/delivery-agents',
    getDeliveryAgentFilterLink: '/retailer/deliveryagent-filters',
    getDeliveryAgentByIdLink: '/retailer/delivery-agents',
    deliveryAgentOrderSats: '/retailer/deliveryagent-orderstats',
    deliveryAgentPayouts: '/retailer/deliveryagent-payouts',
    deliveryAgentPaymentUpdate: '/retailer/deliveryagent-payment-upd',

    // Service Provider Management
    addServiceProviderLink: '/retailer/add-serviceprovider',
    editServiceProviderLink: '/retailer/edit-serviceprovider',
    getServiceProviderLink: '/retailer/serviceproviders',
    getServiceProviderFilterLink: '/retailer/serviceprovider-filters',
    getServiceProviderByIdLink: '/retailer/serviceprovider',
    getServiceProvidersByCategoryLink: '/retailer/serviceproviders-by-category',
    getServiceProviderOrderSats: '/retailer/serviceprovider-orderstats',
    getServiceProviderPayouts: '/retailer/serviceprovider-payouts',
    serviceProviderPaymentUpdate: '/retailer/serviceprovider-payment-upd',
    getServiceBookingsLink: '/retailer/service-bookings',
    getServiceBookingByIdLink: '/retailer/service-bookings',
    assignServiceProviderToBookingLink: '/retailer/assign-service-provider',

    getZoneListAPI: "/retailer/zones",
}

export const STATS_DATE_OPTIONS = [
    "Today",
    "Yesterday",
    "This Week",
    "Last Week",
    "Current Month",
    "Last Month"
];
